export const COUNTRY_CODE_MAX_LENGTH = 3;
export const countryCodeValidator = (t) => (input) => {
    const minLength = 2;
    let err = null;
    if (input.length < minLength) {
        err = t('countries.validation.country-code-too-short', { minLength });
    } else if (input.length > COUNTRY_CODE_MAX_LENGTH) {
        err = t('countries.validation.country-code-too-long', { maxLength: COUNTRY_CODE_MAX_LENGTH });
    } else if (!input.match(/^[a-zA-Z]*$/)) {
        err = t('countries.validation.country-code-only-letters');
    }
    return err;
};

export const COUNTRY_NAME_MAX_LENGTH = 128;
export const countryNameValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('countries.validation.country-name-empty');
    } else if (input.length > COUNTRY_NAME_MAX_LENGTH) {
        err = t('countries.validation.country-name-too-long', { maxLength: COUNTRY_NAME_MAX_LENGTH });
    }
    return err;
};
